import React from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import { mockData } from '../mock';

const FooterSection = ({ onShowPrivacyPolicy }) => {
  return (
    <footer className="footer" data-testid="footer-section">
      <div className="footer-qr-section">
        <div className="section-container">
          <h3 className="footer-qr-title">Download Our Mobile App</h3>
          <div className="footer-qr-container">
            <div className="footer-qr-card">
              <div className="qr-header">
                <Download className="qr-icon" size={24} />
                <h4 className="qr-title">iOS App</h4>
              </div>
              <div className="qr-code-wrapper-footer">
                <img
                  src="https://customer-assets.emergentagent.com/job_asset-planner-3/artifacts/w6w3tlra_image.png"
                  alt="iOS App QR Code"
                  className="qr-code-image-footer"
                />
              </div>
              <p className="qr-instruction">Scan for iPhone</p>
            </div>
            <div className="footer-qr-card">
              <div className="qr-header">
                <Download className="qr-icon" size={24} />
                <h4 className="qr-title">Android App</h4>
              </div>
              <div className="qr-code-wrapper-footer">
                <img
                  src="https://customer-assets.emergentagent.com/job_asset-planner-3/artifacts/akytzq91_image.png"
                  alt="Android App QR Code"
                  className="qr-code-image-footer"
                />
              </div>
              <p className="qr-instruction">Scan for Android</p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-content">
        <div className="footer-section">
          <h4 className="footer-title">APK FINTECH</h4>
          <p className="footer-text">Your trusted partner in wealth creation and financial growth.</p>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">Quick Links</h4>
          <div className="footer-links">
            <Link to="/about" className="footer-link">The APK Advantage</Link>
            <Link to="/services" className="footer-link">Services</Link>
            <Link to="/testimonials" className="footer-link">Client Stories</Link>
            <a
              href="https://apkfintech.my-portfolio.co.in/app/#/login"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Portfolio Tracker
            </a>
            <Link to="/contact" className="footer-link">Contact</Link>
            <button
              onClick={onShowPrivacyPolicy}
              className="footer-link footer-link-button"
              data-testid="privacy-policy-btn"
            >
              Privacy Policy
            </button>
          </div>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">Services</h4>
          <div className="footer-links">
            <Link to="/services" className="footer-link">Mutual Funds</Link>
            <Link to="/services" className="footer-link">PMS & AIFs</Link>
            <Link to="/services" className="footer-link">Inheritance Planning</Link>
            <Link to="/services" className="footer-link">Home Loans</Link>
            <Link to="/services" className="footer-link">Tax Filing</Link>
          </div>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">Contact</h4>
          <div className="footer-links">
            <p className="footer-text">{mockData.contact.phone}</p>
            <p className="footer-text">{mockData.contact.email}</p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-disclaimer" data-testid="footer-disclaimer">
          <p className="disclaimer-text">
            <strong>Disclaimer:</strong> This communication is for investor education and awareness purposes only. Mutual Fund investments are subject to market risks. Please read all scheme-related documents carefully before investing. Past performance is not indicative of future results. Historical data referenced is from publicly available market sources. This does not constitute investment advice. Please consult your financial advisor before making investment decisions. SEBI Registered MF Distributor | ARN-184604 | APMI Registered PMS Distributor | APMI-00335 | Valid upto: 10-04-2029 Please verify at <a href="https://www.amfiindia.com" target="_blank" rel="noopener noreferrer" className="disclaimer-link">www.amfiindia.com</a>
          </p>
        </div>
        <p className="footer-copyright">
          &copy; 2026 APK FINTECH Private Limited. All rights reserved. |
          <button
            onClick={onShowPrivacyPolicy}
            className="footer-privacy-link"
          >
            Privacy Policy
          </button>
        </p>
      </div>
    </footer>
  );
};

export default FooterSection;
